import { HttpParams } from '@angular/common/http';
import { AbstractMapper } from './abstract-mapper';
import * as moment from 'moment';

export class GenericQueryMapper extends AbstractMapper {
    constructor(private dateRanges: string[] = []) {
        super();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    protected customMapping(query: any): HttpParams {
        for (const range of this.dateRanges) {
            if (
                query[`${range}[]`] &&
                query[`${range}[]`].length == 2 &&
                query[`${range}[]`][0] != null
            ) {
                query[`${range}[]`][0] = moment(query[`${range}[]`][0])
                    .startOf('day')
                    .toISOString();
                query[`${range}[]`][1] = moment(
                    query[`${range}[]`][1] || query[`${range}[]`][0]
                )
                    .endOf('day')
                    .toISOString();
            } else {
                delete query[`${range}[]`];
            }
        }
        return new HttpParams({ fromObject: query });
    }
}
